import { Client } from '@connectrpc/connect';

import { HealthService } from './espb/health_service_pb';

export default class HealthServiceClient {
  constructor(private readonly espbClient: Client<typeof HealthService>) {}

  async ping(): Promise<void> {
    await this.espbClient.ping({});
  }
}
